import React, { useContext, useMemo } from 'react';
import { Drawer, Optional } from '@honda-canada/design-system-react';

import DrawerItems from './DrawerItems';
import HeaderContext from '../service/HeaderContext';
import MenuMobileAccordion from './Accordion';
import { customDrawerThemeStyles } from '../styles/Header.styles';
import { primaryNavItemDisplayTarget } from '../service/utils';

const MenuMobile = () => {
  const {
    setIsOpenMenu,
    isOpenMenu,
    setSubMenuList,
    mobileMenuLikeAccordion,
    languageMenu,
    mobileMenuLikeDrawer,
    primaryItems,
    getPrimaryNavItemsToRender,
  } = useContext(HeaderContext);

  const handlerHeaderMobileMenuButton = () => {
    setSubMenuList({});
    setIsOpenMenu(prevState => !prevState);
  };

  const primaryItemsToRender = useMemo(
    () => getPrimaryNavItemsToRender(primaryItems, primaryNavItemDisplayTarget.mobile),
    [primaryItems],
  );

  return (
    <Drawer
      key="mainDrawer"
      width="100%"
      onClose={handlerHeaderMobileMenuButton}
      visible={isOpenMenu}
      fixPosition
      destroyOnClose
      underHeader
      closable={false}
      placement="left"
      themeStylesCustom={customDrawerThemeStyles}
      footer={
        <Optional when={mobileMenuLikeDrawer}>
          <DrawerItems items={[languageMenu]} isFirstLevel isFooter />
        </Optional>
      }
    >
      <Optional when={mobileMenuLikeAccordion}>
        <MenuMobileAccordion items={primaryItemsToRender} />
      </Optional>
      <Optional when={mobileMenuLikeDrawer}>
        <DrawerItems items={primaryItemsToRender} isFirstLevel />
      </Optional>
    </Drawer>
  );
};

export default MenuMobile;
